import { useEffect } from 'react';
import ShoppingCart from '../../components/molecules/ShoppingCart';
import { ViewRoot, ViewContent, ViewContentCenter, ViewSidebar } from '../../layout/Main/styled';
import { dynamicCustomEventTracking } from '../../lib/gtm';
import { OyanaAdress } from '../../components/molecules/OyanaAddress';

const OyanaAddress = () => {
  useEffect(() => {
    dynamicCustomEventTracking.send({ dynamicEventName: 'journey_quick_access_address_ag' });
  }, []);
  return (
    <>
      <ViewRoot>
        <ViewContent className="ViewContent">
          <ViewContentCenter>
            <OyanaAdress />
          </ViewContentCenter>
        </ViewContent>
        <ViewSidebar component="aside" className="ViewSidebar">
          <ShoppingCart />
        </ViewSidebar>
      </ViewRoot>
    </>
  );
};

export default OyanaAddress;
